import { useEffect, useState } from 'react';
import { AbsenceReportApi } from '../../../api';
import { AbsenceReportApiResponse } from '../../../api/AbsenceReportApi';
import { useContainer } from '../../useContainer';

type MonthlyDetailData = AbsenceReportApiResponse.GetMonthlyDetail['body'];

const EMPTY_DATA: MonthlyDetailData = {
    scope: { type: 'ORGANIZATION' },
    days: [],
};

export interface IGetMonthlyDetailQuery {
    month: number;
    year: number;
    projectId?: string;
    enabled?: boolean;
}

const useHttpGetMonthlyDetail = (query: IGetMonthlyDetailQuery) => {
    const absenceReportApi: AbsenceReportApi = useContainer(AbsenceReportApi);
    const [data, setData] = useState<MonthlyDetailData>(EMPTY_DATA);
    const [isReady, setIsReady] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        if (query.enabled === false) return;

        setIsReady(false);
        setIsError(false);
        const { exec, abort } = absenceReportApi.getMonthlyDetail({
            query: { month: query.month, year: query.year, projectId: query.projectId },
            onSuccess: res => {
                setData(res.body);
                setIsError(false);
            },
            onError: () => setIsError(true),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    }, [query.month, query.year, query.projectId, query.enabled]);

    return { data, isReady, isError };
};

export default useHttpGetMonthlyDetail;
